import React, {Component} from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from "../components/CircularProgress/index";


const componentLoaded = {};

export default function asyncComponent(importComponent,key) {

  if(key && componentLoaded[key]){
    class SyncFunc extends Component {  //对于已加载过的组件，虽然也是异步加载，但是是本地异步加载，不会访问远程JS，因此不再需要显示加载进度条
      constructor(props) {
        super(props);
        this.state = {
          component: null
        };
      }
  

      componentWillUnmount() {
        this.mounted = false;
      }
  
      async componentDidMount() {
        this.mounted = true;
        const {default: Component} = await importComponent();
        if (this.mounted) {
          this.setState({
            component: <Component {...this.props} />
          });
        }
      }
  
      render() {
        const Component = this.state.component || <div className="d-none"></div>;
        return (
          <ReactPlaceholder type="text" rows={1} ready={Component !== null}>
            {Component}
          </ReactPlaceholder>
        );
      }
    }
  
    return SyncFunc;
  }
  else{
    class AsyncFunc extends Component {
      constructor(props) {
        super(props);
        this.state = {
          component: null
        };
      }
  
      componentWillMount() {
        Nprogress.start();
      }
  
      componentWillUnmount() {
        this.mounted = false;
      }
  
      async componentDidMount() {
        this.mounted = true;
        const {default: Component} = await importComponent();
        Nprogress.done();
        if(key)
          componentLoaded[key] = true;
        if (this.mounted) {
          this.setState({
            component: <Component {...this.props} />
          });
        }
      }
  
      render() {
        const Component = this.state.component ||
          <div className="loader-view"
               style={{height: 'calc(100vh - 200px)'}}>
            <CircularProgress/>
          </div>;
        return (
          <ReactPlaceholder type="text" rows={1} ready={Component !== null}>
            {Component}
          </ReactPlaceholder>
        );
      }
    }
  
    return AsyncFunc;
  }

  
}